import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import cloudStore, { cloudStoreEvents } from "../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useParams } from "react-router-dom";
import WebcodeSettings from "../components/WebcodeSetting/WebcodeSetting";
import { Grid, MenuItem, Select } from "@material-ui/core";
import withIntl from "../utils/withIntl";
import Button from "@material-ui/core/Button";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import SelectSalesAreaMerchant from "../components/CreateSalesArea/SelectSalesAreaMerchant";
import { useDialog } from "../components/Dialogs/DialogProvider";
import { Pagination } from "@material-ui/lab";
import DialogOkOrCancel from "../components/Dialogs/DialogOkOrCancel";
import { deleteQrCodes } from "../components/WebcodeSetting/WebcodeApi";
import { getMerchantFromServer } from "../store/CloudActions";

function QRCodes(props) {
  const [openDialog] = useDialog();
  const params = useParams();
  const spMerchantId = Number.parseInt(params.spMerchantId);
  const taMerchantId = Number.parseInt(params.taMerchantId);
  const [merchant, setMerchant] = useState(cloudStore.merchant);
  const spMerchant = merchant?.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);
  const taMerchant = merchant?.ta_merchants.find((taMerchant) => taMerchant.id === taMerchantId);
  const [selectedQrCodeIdentifiers, setSelectedQrCodeIdentifiers] = useState({});
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(16);

  const onChangeMerchant = () => {
    setMerchant(cloudStore.merchant);
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
  }, []);

  const spQrCodes = React.useMemo(() => {
    let codes = [];

    if (spMerchant) {
      codes = spMerchant.sp_qr_codes.sort((x, y) => parseInt(x.table_id) - parseInt(y.table_id));
    }

    if (taMerchant) {
      codes = codes.concat(taMerchant.sp_qr_codes.sort((x, y) => parseInt(x.table_id) - parseInt(y.table_id)));
    }
    return codes;
  }, [spMerchant, taMerchant]);

  if (!spMerchant && !taMerchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  const setSelectedSpQrCodeIdentifier = (identifier, checked) => {
    const newSelected = { ...selectedQrCodeIdentifiers };
    if (checked) {
      newSelected[identifier] = checked;
    } else {
      delete newSelected[identifier];
    }

    setSelectedQrCodeIdentifiers(newSelected);
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          // justifyContent: "space-between",
        }}
      >
        <Typography variant="h4">
          {spMerchant != null ? "In House" : "Takeaway"} QR codes - {merchant.name}
        </Typography>
      </div>
      {/* This Button uses a Font Icon, see the installation instructions in the Icon component docs. */}
      <Divider style={{ marginBottom: "10px" }} />

      <AuthorizationWrapper
        permission={"qr_codes.move"}
        child={(write) => {
          return (
            <Button
              variant={"outlined"}
              disabled={!write}
              onClick={(e) => {
                const newSelected = { ...selectedQrCodeIdentifiers };

                if (spMerchant?.sp_qr_codes) {
                  spMerchant.sp_qr_codes.forEach((spQrCode) => {
                    newSelected[spQrCode.identifier] = true;
                  });
                }
                if (taMerchant?.sp_qr_codes) {
                  taMerchant.sp_qr_codes.forEach((spQrCode) => {
                    newSelected[spQrCode.identifier] = true;
                  });
                }
                setSelectedQrCodeIdentifiers(newSelected);
              }}
            >
              Select all QrCodes
            </Button>
          );
        }}
      />
      {Object.keys(selectedQrCodeIdentifiers).length > 0 && (
        <Button
          variant={"outlined"}
          onClick={() => {
            openDialog({
              children: (
                <SelectSalesAreaMerchant
                  selectedSpQrCodes={selectedQrCodeIdentifiers}
                  merchantId={params.merchantId}
                  onUpdated={() => {
                    setSelectedQrCodeIdentifiers({});
                    getMerchantFromServer(merchant.id);
                  }}
                />
              ),
            });
          }}
        >
          Move QrCodes
        </Button>
      )}
      {Object.keys(selectedQrCodeIdentifiers).length > 0 && (
        <Button
          variant={"outlined"}
          onClick={() => {
            openDialog({
              children: (
                <DialogOkOrCancel
                  content={"Do you really want to delete the selected QRCodes? This is can not be undone!"}
                  title={"Warning!"}
                  onOkClicked={(e) => {
                    deleteQrCodes(
                      params.merchantId,
                      Object.keys(selectedQrCodeIdentifiers).map((identifier) => ({ identifier }))
                    ).then(() => {
                      setSelectedQrCodeIdentifiers({});
                      getMerchantFromServer(merchant.id);
                    });
                  }}
                />
              ),
            });
          }}
        >
          Delete QrCodes
        </Button>
      )}
      <Pagination
        color={"primary"}
        count={Math.ceil(spQrCodes.length / rowsPerPage)}
        page={page}
        showFirstButton={true}
        showLastButton={true}
        onChange={(e, page) => {
          setPage(page);
        }}
      />
      <Grid container>
        {spQrCodes.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((spQrCode, i) => {
          return (
            <WebcodeSettings
              merchantType={spQrCode.sp_merchant_id ? "spMerchant" : "taMerchant"}
              webcode={spQrCode}
              key={spQrCode.identifier}
              index={i + (page - 1) * rowsPerPage}
              selectedQrCodeIdentifiers={selectedQrCodeIdentifiers}
              setSelectedSpQrCodeIdentifier={setSelectedSpQrCodeIdentifier}
            />
          );
        })}
      </Grid>
      <Pagination
        color={"primary"}
        count={Math.ceil(spQrCodes.length / rowsPerPage)}
        page={page}
        showFirstButton={true}
        showLastButton={true}
        onChange={(e, page) => {
          setPage(page);
        }}
      />
      <Select value={rowsPerPage} onChange={(e) => setRowsPerPage(e.target.value)}>
        <MenuItem value={16}>16</MenuItem>
        <MenuItem value={50}>50</MenuItem>
        <MenuItem value={100}>100</MenuItem>
        <MenuItem value={200}>200</MenuItem>
      </Select>
    </div>
  );
}

export default withIntl(QRCodes);
